import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import apiClient from "../../apiClient";
import MediaGalleryModal from "../Details/MediaGalleryModal";
import { generateShortUUID, pointerMediaFileTypes } from "../../utils/constants";
import { CancelIcon, EditIcon, FoldDown, FoldRight, TickHere } from "../../Static/icons/iconshere";
import { FETCH_AR_ANCHOR_POINTERS, UPDATE_AR_ANCHOR_POINTERS } from "../../apiClient/apiEndpoints";
import { AR_CONTENT_HOTSPOT_FILE } from "../../constant/limitSize";
import { VALUE } from "../../constant/constant";
import { getAllowedMaxFileSize, isFileSizeOverMaxSize } from "../../utils/common";

const AnchorPoints = ({ uuid }) => {
  const [close, setClose] = useState(false);
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);
  const UNO_URL = configData?.config?.UNO_URL;
  const [fileUploadError, setFileUploadError] = useState(null);
  const [cloudPointersList, setCloudPointersList] = useState([]);
  const [cloneCloudPointersList, setCloneCloudPointersList] = useState([]);
  const [uploadedProductFiles, setUploadedProductFiles] = useState({
    openModel: false,
    id: "",
    onlyView: true
  });

  const fetchBasicModuleDetails = async () => {
    try {
      const detail = await apiClient.get(`${UNO_URL}${FETCH_AR_ANCHOR_POINTERS}/${uuid}`);
      const pointerList = detail?.versions?.[0]?.data?.blobData?.pointers?.map((pointer) => {
        return {
          id: generateShortUUID(),
          title: pointer?.data?.title || "",
          description: pointer?.data?.description || "",
          files: pointer?.data?.files || [],
        };
      }) || [];
      let _pointerList = pointerList.map(e => ({ ...e, editable: false, isOpen: false }));
      setCloudPointersList(_pointerList);
      setCloneCloudPointersList(_pointerList);
    } catch (error) {
      console.log(error);
    }
  };



  useEffect(() => {
    if (uuid) {
      fetchBasicModuleDetails();
    }
  }, [uuid]);

  const handleChangeItemValue = (field, value, id) => {
    setCloudPointersList(prev => prev.map((hotspot) => hotspot.id === id ? { ...hotspot, [field]: value } : hotspot))
  }

  const handleCancelEditable = (id) => {
    let findPreValue = cloneCloudPointersList.find(e => e.id === id);
    setCloudPointersList(prev => prev.map((hotspot) => hotspot.id === id ? { ...findPreValue } : hotspot))
  }

  const handleShowHotspotMediaModal = (item) => {
    handleChangeItemValue("isOpen", true, item.id)
    setUploadedProductFiles({
      openModel: true,
      id: item.id,
      onlyView: !(item.editable)
    });
  };

  const handleSaveUpdateValue = async (data, index) => {
    try {
      let bodyData = {
        pointerData: {
          title: data.title,
          description: data.description,
          files: data.files,
        },
        index: index
      }

      await apiClient.post(`${UNO_URL}${UPDATE_AR_ANCHOR_POINTERS}/${uuid}`, bodyData);

      handleChangeItemValue("editable", false, data.id)

    } catch (error) {
      console.log(error);
    }
  }

  const closeMediaModal = () => {
    handleChangeItemValue("isOpen", false, uploadedProductFiles.id)
    setUploadedProductFiles({
      openModel: false,
      id: "",
      onlyView: true
    });
  };

  const handlePointerMediaUpload = async (files) => {
    try {
      if (!files) return;
      const file = files;

      if (isFileSizeOverMaxSize(file.size, AR_CONTENT_HOTSPOT_FILE)) {
        setFileUploadError(`File size is more then ${getAllowedMaxFileSize(AR_CONTENT_HOTSPOT_FILE)}`)
        return;
      }

      const extension = file.name.split(".").pop().toLowerCase();
      if (!pointerMediaFileTypes.includes(extension)) {
        alert(`Invalid file type. Allowed types: ${pointerMediaFileTypes}`);
        return;
      }
      let fileType = "image";
      if (file.type.startsWith("video/")) {
        fileType = "video";
      } else if (file.type === "application/pdf") {
        fileType = "pdf";
      }

      const formData = new FormData();
      formData.append("file", file);
      const res = await axios.post(`${UNO_URL}/api/resource/ar/upload/${fileType}/${uuid}`, formData, {
        headers: {
          "Content-Type ": "multipart/form-data",
          Authorization: `Bearer ${userData?.token}`,
        },
      });


      setCloudPointersList((prev) => {
        return prev.map((pointer) => {
          if (pointer.isOpen) {
            return { ...pointer, files: [...(pointer.files || []), res?.data?.url] };
          } else {
            return pointer;
          }
        });
      });


    } catch (error) {
      console.log(error);
    }
  };

  const deletePointerMediaHandler = (_, url) => {
    setCloudPointersList((prev) => {
      return prev.map((pointer) => {
        if (pointer.isOpen) {
          return { ...pointer, files: pointer.files?.filter((fileUrl) => fileUrl !== url) };
        } else {
          return pointer;
        }
      });
    });
  };

  return (
    <>
      <div className={`detail-component for-anchors  mt-3 ${close ? "closed" : ""} `}>
        <h6>
          Cloud Anchor List
          <span className="OpenCloseBtn" onClick={() => setClose((prev) => !prev)}>
            {!close ? <FoldDown /> : <FoldRight />}
          </span>{" "}
        </h6>
        <div className="uploadBoxItem">
          <div className="uploadBoxHead"></div>
          <div className="mediaList">
            <div className="table-responsive workflowtb mt-2 stickyhead ">
              <table className="table align-middle table-nowrap mb-0">
                <thead>
                  <tr>
                    <th className="text-center">S.No.</th>
                    <th className="w-25">Anchor Name</th>
                    <th className="w-50">Anchor Description</th>
                    <th className="text-center">Media Files</th>
                    <th className="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody className="versiontable">
                  {cloudPointersList.map((item, index) => (

                    <tr>
                      <td className="text-center">{index + 1}</td>
                      <td>{item.editable ? <input value={item.title} name="title" onChange={(e) => handleChangeItemValue(e.target.name, e.target.value, item.id)} /> : item.title}</td>
                      <td>{item.editable ? <textarea value={item.description} name="description" onChange={(e) => handleChangeItemValue(e.target.name, e.target.value, item.id)} /> : item.description}</td>
                      <td className="text-center">
                        <div className="media-wrapper">
                          <p>{item.files.length} Media Files</p>
                          <span className="addFile" onClick={() => handleShowHotspotMediaModal(item)} >View{item.editable && "/Upload"} Files</span>
                        </div>
                      </td>
                      <td className="text-center">
                        <div className="table-action-btns">
                          {item.editable ? (
                            <>
                              <span onClick={() => handleSaveUpdateValue(item, index)}> <TickHere /> </span>
                              <span className="cancel" onClick={() => handleCancelEditable(item.id)}> <CancelIcon /> </span>
                            </>
                          ) : (
                            <span onClick={() => handleChangeItemValue("editable", !item.editable, item.id)}> <EditIcon /> </span>
                          )}
                        </div>
                      </td>
                    </tr>

                  ))}

                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <MediaGalleryModal
        mediaGalleryShow={uploadedProductFiles.openModel}
        GalleryClose={closeMediaModal}
        fileTypes={pointerMediaFileTypes}
        handleProductImageChange={handlePointerMediaUpload}
        allSavedFileUrl={cloudPointersList?.find(e => e.id === uploadedProductFiles.id)?.files?.map((url) => ({ url })) || []}
        deleteProductImage={deletePointerMediaHandler}
        uploadedProductFiles={[]}
        saveProductImagesFile={closeMediaModal}
        multipleUpload={false}
        maxFileSize={AR_CONTENT_HOTSPOT_FILE[VALUE]}
        showCloseButton={false}
        onlyView={uploadedProductFiles.onlyView}
        fileUploadError={fileUploadError}
      />

    </>
  );
};

export default AnchorPoints;
